var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionList',{attrs:{"apiParams":"1722"}})
}
var staticRenderFns = []

export { render, staticRenderFns }